import { useBaseValueRetrieval } from '@/hooks/invoice_reports/useBaseValueRetrieval';
import type { ValueTransformer } from '@/hooks/invoice_reports/useShowSearchValue';
import { BaseOption } from '@/hooks/useTypeToOptions';
import { useCallback, useMemo } from 'react';

export const useApCounterpartyTransformer = (
  counterpartyOptions?: BaseOption[]
) => {
  const { getApCounterpartyValue } = useBaseValueRetrieval();

  const apCounterpartyTransformer: ValueTransformer = useCallback(
    (v) => {
      const ids = Array.isArray(v) ? v : typeof v === 'string' ? [v] : [];
      return ids.reduce<string[]>((acc, id) => {
        if (!id) return acc;
        const name = getApCounterpartyValue(id, counterpartyOptions);
        if (name === id) return acc;
        acc.push(name);
        return acc;
      }, []);
    },
    [getApCounterpartyValue, counterpartyOptions]
  );

  return useMemo(
    () => ({
      ap_counterparty_ids: apCounterpartyTransformer,
    }),
    [apCounterpartyTransformer]
  );
};
